import { render, staticRenderFns } from "./IdeaList.vue?vue&type=template&id=f9e57320&"
import script from "./IdeaList.vue?vue&type=script&lang=js&"
export * from "./IdeaList.vue?vue&type=script&lang=js&"
import style0 from "./IdeaList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports